var React = require('react');

function Listings (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/Listing","stroke":"none","strokeWidth":"1","fill":"currentColor","fillRule":"evenodd"},React.createElement("path",{"d":"M5,3 L15,3 C15.5522847,3 16,3.44771525 16,4 L16,9 C16,9.55228475 15.5522847,10 15,10 L5,10 C4.44771525,10 4,9.55228475 4,9 L4,4 C4,3.44771525 4.44771525,3 5,3 Z M9.5,11 L10.5,11 C10.7761424,11 11,11.2238576 11,11.5 L11,16.5 C11,16.7761424 10.7761424,17 10.5,17 L9.5,17 C9.22385763,17 9,16.7761424 9,16.5 L9,11.5 C9,11.2238576 9.22385763,11 9.5,11 Z","id":"path-1"})));
}

Listings.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1"};

module.exports = Listings;

Listings.default = Listings;
